import React from 'react';

export default ({caseNumber}) => (
  <>
    {caseNumber}
  </>
);
